// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"fd0d4e1284f667877790","293":"dafc706d3ceae0b581ce","518":"d5ef5fa3a3dc15b9c970","779":"e6e49515cb3008f69b91"}[chunkId] + ".js";
};